import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';

import { CLEAR_UI_FEEDBACK } from '../../constants/actionTypes';

//translates the feedback "code" dispatched by actions/playQuiz.js into a message for the current language
const componentContent = {
    language_DE: {
        JOIN_FAILED: 'Quiz nicht gefunden. Bitte PIN prüfen.',
        CREATE_FAILED: 'Quiz konnte nicht erstellt werden. Bitte erneut versuchen.'
    },
    language_EN: {
        JOIN_FAILED: 'Quiz not found. Please check the PIN.',
        CREATE_FAILED: 'Could not create the quiz. Please try again.'
    },
    language_FR: {
        JOIN_FAILED: 'Quiz introuvable. Veuillez vérifier le code PIN.',
        CREATE_FAILED: 'Impossible de créer le quiz. Veuillez réessayer.'
    }
}

const GlobalSnackbar = () => {
    const dispatch = useDispatch();
    const feedback = useSelector((state) => state.UiFeedback);
    const selectedLanguage = useSelector((state) => state.Language);

    const handleClose = (event, reason) => {
        if(reason === 'clickaway'){
            return;
        }
        dispatch({ type: CLEAR_UI_FEEDBACK });
    };

    return (
        <Snackbar
            open={!!feedback}
            autoHideDuration={5000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            {feedback ?
                <Alert onClose={handleClose} severity={feedback.severity} variant="filled" sx={{ width: '100%' }}>
                    {componentContent[selectedLanguage][feedback.code]}
                </Alert>
                : undefined
            }
        </Snackbar>
    );
};

export default GlobalSnackbar;
